import React from 'react';

const Spinner = () => {
    return (
        <div>
            <div className="spinner-border text-dark" role="status">
                <span className="sr-only"></span>
            </div>
        </div>
    );
};

export default Spinner;
